import $ from 'jquery'

class SpinnerService {
    constructor() {
        this.spinner = $("#overlay");
    }

    showSpinner() {
        this.spinner.css("display", "flex")
    }

    hideSpinner() {
        this.spinner.css("display", "none")
    }
}

export default SpinnerService;


// WEBPACK FOOTER //
// ./client/app/_services/spinner.service.js